import { ICoreLogger } from "../api/ICoreLogger";
import { LoggingLevel } from "../api/LoggingLevel";
import { ILogger } from "js-logger";
const Logger: ILogger = require("js-logger");

/**
 * @private
 */
export class CoreLogger implements ICoreLogger {
    private _realLogger: ILogger;

    constructor(realLogger: ILogger) {
        this._realLogger = realLogger;
    }

    enabledFor(level: LoggingLevel): boolean {
        return this._realLogger.enabledFor(LoggingLevelMapper.get(level));
    }

    time(label: string): void {
        Logger.time(label);
    }

    timeEnd(label: string): void {
        Logger.timeEnd(label);
    }

    public get name(): string {
        return (this._realLogger as any).context.name; // relies on interal `ContextualLogger` implementation
    }

    public debug(message: any, ...parameters: any[]): void {
        // TODO @HTML5  string literals out of params not yet implemented
        //  TODO  IF WE WANT TO KNOW WHERE THE LOG IS COMING FROM WE COULD   parameters.push(new Error().stack);
        // and THEN PARSE IT (the real callee is usually the second line of the stack (the immediate calle is CoreLogger.debug which is not interesting for us)  + maybe use some library like stacktrace-gps to point that to sourcemap
        if (this.debugEnabled) {
            this._realLogger.debug.call(this._realLogger, message, ...parameters);
        }
    }

    public info(message: any, ...parameters: any[]): void {
        if (this.infoEnabled) {
            this._realLogger.info.call(this._realLogger, message, ...parameters);
        }
    }

    public warn(message: any, ...parameters: any[]): void {
        if (this.warnEnabled) {
            this._realLogger.warn.call(this._realLogger, message, ...parameters);
        }
    }

    public error(message: any, ...parameters: any[]): void {
        if (this.errorEnabled) {  //add short-circuit if to memoize logging levels
            this._realLogger.error.call(this._realLogger, message, ...parameters);
        }
    }

    public get debugEnabled(): boolean {
        return this.enabledFor(LoggingLevel.DEBUG);
    }

    public get infoEnabled(): boolean {
        return this.enabledFor(LoggingLevel.INFO);
    }

    public get warnEnabled(): boolean {
        return this.enabledFor(LoggingLevel.WARN);
    }

    public get errorEnabled(): boolean {
        return this.enabledFor(LoggingLevel.ERROR);
    }

    setLevel(logLevel: LoggingLevel): void {
        this._realLogger.setLevel(LoggingLevelMapper.get(logLevel));
    }


}


/**
 * mapping our Logging levels with those from used library (currently js-logger)
 * @type {Map<K, V>}
 */
export const LoggingLevelMapper: Map<LoggingLevel, any> = new Map(
    [
        [LoggingLevel.DEBUG, Logger.DEBUG],
        [LoggingLevel.INFO, Logger.INFO],
        [LoggingLevel.WARN, Logger.WARN],
        [LoggingLevel.ERROR, Logger.ERROR],
        [LoggingLevel.NONE, Logger.OFF]
    ]);
